import { reducer } from './reducer';
import { sagas } from './sagas';


export const pagination = {
    reducer,
    sagas,
};
